import { UNEXPECTED_ERROR_MESSAGE } from '@/const/shared';
import { useEffect } from 'react';
import { isString } from '@/helpers/objectHelpers';

// Note: Stripe could throw an unhandled rejections via under-the-hood requests, so we need to catch it properly
export const useCatchStripeInitError = (onError: (error: string) => void) => {
  const errorRejectionHandler = (rejectionEvent: PromiseRejectionEvent) => {
    // Extract the error from the event
    const error = rejectionEvent.reason;

    // Handle different error types
    if (error instanceof Error) {
      onError(error?.message);
    } else if (isString(error)) {
      onError(error);
    } else {
      onError(UNEXPECTED_ERROR_MESSAGE);
    }
  };

  useEffect(() => {
    window.addEventListener('unhandledrejection', errorRejectionHandler);

    return () => {
      window.removeEventListener('unhandledrejection', errorRejectionHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
